import React from "react";
import logo from '../assets/pictures/logo-rms.png'
import Menu from '../components/Menu'

function Header(){        
        return (
        <div id="header-holder" className="headertop sticky">
            <div id="header">
                <div className="container">
                    <div id="banner">
                        <div id="banner-logo-tagline">
                            <div id="banner-logo">                                    
                                <img src={logo} alt="Rock Minut Soup"/>
                            </div>
                            <div id="banner-tagline">Rock Minut Soup</div>
                        </div>
                        <div id="primary-nav">
                            <div id="main-menu-holder">
                                <Menu></Menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    
}

export default Header;